import { inkElevationTokens } from '@ds/tokens'

const tokens = {
  low: inkElevationTokens.elevationLow,
  medium: inkElevationTokens.elevationMedium,
  highest: inkElevationTokens.elevationHighest,
} as const

export default tokens
